import { signal } from 'services/SignalsService'
import { randomSettings } from 'settings/custom/animations'
import { delay } from 'utils/Delay'
import { getRandomInt } from 'utils/Random'

function init() {
  Object.keys(randomSettings || {}).forEach(setRandomDelay)
}

async function setRandomDelay(name) {
  const time = getRandomInt(randomSettings[name].min, randomSettings[name].max)

  call('START')
  await delay(time)
  call('STOP')

  return setRandomDelay(name)

  function call(state) {
    signal.dispatch(`ANIM:${name}:${state}`)
  }
}

export const TriggerService = { init }
